import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { ProductSchema } from "../types";
import { makeCreateInputSchema } from "../utils/zod-utils/makeCreateInputSchema";

const c = initContract();

export const productsContract = c.router({
  findAll: {
    method: "GET",
    path: "/products",
    responses: {
      200: ProductSchema.array(),
    },
    summary: "Find all products",
  },

  uploadCustomProducts: {
    method: "POST",
    path: "/products/custom",
    contentType: "multipart/form-data",
    body: c.type<{ file: File }>(),
    responses: {
      200: z.object({
        success: z.boolean(),
      }),
    },
    summary: "Upload custom products",
  },

  create: {
    method: "POST",
    path: "/products",
    body: makeCreateInputSchema(ProductSchema).omit({
      companyId: true,
    }),
    responses: {
      201: ProductSchema,
    },
    summary: "Create a product",
  },

  update: {
    method: "PATCH",
    path: "/products/:id",
    pathParams: z.object({
      id: z.string(),
    }),
    body: ProductSchema.pick({
      name: true,
      price: true,
      fixedPrice: true,
      type: true,
    }).partial(),
    responses: {
      200: ProductSchema,
    },
    summary: "Update a product",
  },

  delete: {
    method: "DELETE",
    path: "/products/:id",
    pathParams: z.object({
      id: z.string(),
    }),
    body: z.object({}),
    responses: {
      200: z.object({
        success: z.boolean(),
      }),
    },
    summary: "Delete a product",
  },
});
